<template>
  <v-layout wrap justify-left align-center>
    <v-dialog v-model="dialogChangePassword" persistent scrollable max-width="380">
      <v-card>
        <v-card-title primary-title>
          <span class="display-1">Alterar Senha</span>
        </v-card-title>
        <v-divider></v-divider>
          <v-card-text style="height: 240px;">
            <v-form @keyup.native.esc="close" @keyup.native.enter="customFilter(null, postFilter)">
              <v-flex xs12>
                <v-text-field prepend-icon="lock" autocomplete="current-password" name="oldPassword" label="Senha Atual" type="password" autofocus
                              v-model="editedItem.oldPassword" v-on:keydown.enter="confirm"/>
              </v-flex>
              <v-flex xs12>
                <v-text-field prepend-icon="lock" autocomplete="new-password"  name="newPassword" label="Senha Nova" id="newPassword"
                              type="password" v-model="editedItem.newPassword" v-on:keydown.enter="confirm"/>
              </v-flex>
              <v-flex xs12>
                <v-text-field prepend-icon="lock" autocomplete="new-password"  name="newPasswordConfirm" label="Confirmação de Senha" id="newPasswordConfirm"
                              type="password" v-model="editedItem.newPasswordConfirm" v-on:keydown.enter="confirm"/>
              </v-flex>
            </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="confirm">Confirmar</v-btn>
          <v-btn color="green darken-1" flat @click="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style scoped>
</style>

<script>
  export default {
    name: 'PChangePassword',
    data () {
      return {
        dialogChangePassword: false,
        editedItem: {newPassword: '', oldPassword: '', newPasswordConfirm: ''}
      }
    },
    methods: {

      confirm: function () {
        if (this.editedItem.newPassword !== this.editedItem.newPasswordConfirm) { return alert('A senha nova não confere com sua confirmação.') }

        this.$http.post('api/change_password', this.editedItem).then(
          (res) => {
            alert(res.body)
            this.editedItem.newPassword = ''
            this.editedItem.oldPassword = ''
            this.editedItem.newPasswordConfirm = ''
          })
        this.dialogChangePassword = false
      },
      close: function () {
        this.dialogChangePassword = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PChangePassword.vue